import { render, staticRenderFns } from "./PersonExtraWorkListMob.vue?vue&type=template&id=022b5b94&scoped=true&"
import script from "./PersonExtraWorkListMob.vue?vue&type=script&lang=js&"
export * from "./PersonExtraWorkListMob.vue?vue&type=script&lang=js&"
import style0 from "./PersonExtraWorkListMob.vue?vue&type=style&index=0&id=022b5b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b5b94",
  null
  
)

export default component.exports